import { render, staticRenderFns } from "./ToModal.vue?vue&type=template&id=66910d59&"
import script from "./ToModal.vue?vue&type=script&lang=js&"
export * from "./ToModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports